var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconActionHrInterview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "10 10 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.3776 27.5523V25.8825C23.3776 24.9968 23.0257 24.1473 22.3994 23.521C21.7731 22.8947 20.9236 22.5428 20.0379 22.5428H15.0284C14.1427 22.5428 13.2932 22.8947 12.6669 23.521C12.0406 24.1473 11.6887 24.9968 11.6887 25.8825V27.5523",
    stroke: "currentColor",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5331 19.2031C19.3776 19.2031 20.8728 17.7079 20.8728 15.8635C20.8728 14.019 19.3776 12.5238 17.5331 12.5238C15.6887 12.5238 14.1935 14.019 14.1935 15.8635C14.1935 17.7079 15.6887 19.2031 17.5331 19.2031Z",
    stroke: "currentColor",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3779 19.2031L25.0477 20.873L28.3874 17.5333",
    stroke: "currentColor",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconActionHrInterview);
export default __webpack_public_path__ + "static/media/icon-action-hr-interview.9e1de057622059b9453c986aecc3221b.svg";
export { ForwardRef as ReactComponent };